var render = function render(){var _vm=this,_c=_vm._self._c;return _c('manage-password',{attrs:{"customerClass":'mt-5',"title":_vm.$translate('user_profile')}})
}
var staticRenderFns = []

export { render, staticRenderFns }